import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
    ACTION_BUTTON_TYPES as ABT,
    pushToParams,
    requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import MultiSelect from "../../components/form-fields/MultiSelect";
import {getNestedValueFromPath} from "../../utils";

export default function RoleAuth(props) {
    const [showModal, setShowModal] = useState(false);
    const [configData, setConfigData] = useState(null);
    const [refreshList, setRefreshList] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);


    const validationSchema = yup.object({
    });

    const arrangeBeforePersist = (values) => {
        let payload = {
            yetkiEntities: values.yetkiler.map(y => {
                return {
                    id: y
                }
            }),
            id: getNestedValueFromPath(props,"location.state.row.id"),
        };
        return payload;
    };

    const adaptDataForUpdate = (data) => {
        let adaptedData = {
            yetkiler: data.yetkiEntities.map(ye => ye.id),
        };
        setInitialValues(adaptedData);
    };

    const onUpdateButtonClicked = (selectedRow) => {
        setShowModal(true);
        setIsUpdating(true);
        setSelectedRow(selectedRow);
    };

    const onAddButtonClicked = () => {
        setShowModal(true);
        setIsUpdating(true);
        setInitialValues({});
    };

    const mapNativeDataBeforeList = (data) => {
        data = data.yetkiEntities;
        return data;
    }

    return (
        <Main>
            <div className="row">
                <div className="col-xl-12 col-xxl-12">
                    <CrudMain
                        onAddButtonClicked={onAddButtonClicked}
                        showModal={showModal}
                        setShowModal={setShowModal}
                        title="Rol-Yetki"
                        showBackButton
                        onBackButton={() => props.history.goBack()}
                        customAddButtonTitle={"Güncelle"}
                    >
                        <FormikForm
                            isUpdating={isUpdating}
                            entityId={getNestedValueFromPath(props,"location.state.row.id")}
                            entityFetchId="id"
                            endPointUrl="role/update-yetki"
                            fetchPointUrl="role/find"
                            editPointUrl="role/update-yetki"
                            configPointUrl="role/list-all-yetki"
                            arrangeBeforePersist={arrangeBeforePersist}
                            adaptDataForUpdate={adaptDataForUpdate}
                            setConfigData={(data) => setConfigData(data)}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            closeModal={() => setShowModal(false)}
                            refreshList={() => setRefreshList(!refreshList)}
                        >
                            <Field
                                name="yetkiler"
                                label="Yetkiler"
                                colNumber="12"
                                component={MultiSelect}
                                options={configData && configData.tableData.map(y => {return {value:y.id,label: y.descr}})}
                            />
                        </FormikForm>
                    </CrudMain>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <ListComponent
                        entityName="rol-yetki"
                        endpoint="role/find"
                        keyField="id"
                        refreshList={refreshList}
                        mapNativeDataBeforeList={mapNativeDataBeforeList}
                        customBody={{
                            id: getNestedValueFromPath(props,"location.state.row.id"),
                        }}
                        columns={[
                            {
                                dataField: "descr",
                                text: "Yetki Adı",
                                sort: true,
                            },
                        ]}
                        actionButtonsObject={{
                            actions: [
                            ],
                            generator: DefaultActionButtonGenerator,
                        }}
                    />
                </div>
            </div>
        </Main>
    );
}
